import { Button, DropDownInput } from "@/components";
import { useState } from "react";
import { HiOutlineDownload, HiOutlineUpload } from "react-icons/hi";
import { SheetClose } from "@/components/ui/sheet";
import { UploadInput } from "@/components";
import { useDispatch, useSelector } from "react-redux";
import { uploadCreditNote } from "../../../app/Slices";
import { useAlert, useConfirmationDialog } from "@/";
const CreditNoteBulk = ({ setSheetOpen = () => {} }) => {
  const dispatch = useDispatch();
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const handleChange = (key, value) => {
    setSelectedFile((prev) => ({ ...prev, [key]: value }));
  };
  const [selectedFile, setSelectedFile] = useState({
    bulkCreditNote: null,
  });
  const handleUpload = async () => {
    if (!selectedFile.bulkCreditNote) {
      await alert("Please select a file before uploading.");
      return;
    }
    await confirm("Are you sure you want to upload the Credit Note?");
    try {
      const action = await dispatch(
        uploadCreditNote({ file: selectedFile.bulkCreditNote })
      );

      if (uploadCreditNote.fulfilled.match(action)) {
        // Only close sheet after alert is acknowledged
        await alert("Credit Note Uploaded Successfully");
        setSheetOpen(false);
      } else if (uploadCreditNote.rejected.match(action)) {
        console.error("COD Remittance Upload Failed", action.payload);
        await alert(action.payload || "COD Remittance Upload Failed");
      }
    } catch ({ error }) {
      console.error("API Error:::", error.message);
      await alert("An error occurred while uploading the COD remittance.");
    }
  };
  return (
    <div className="flex flex-col gap-10 pl-2">
      <div className="flex flex-col gap-6">
        {/* Step 1 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">1.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Download sample Credit Note sheet
            </p>
          </div>
          <div className="flex gap-2 justify-start items-center ml-6">
            <Button
              variant="default"
              size="sm"
              icon={HiOutlineDownload}
              onClick={() => {
                window.location.href =
                  "https://api.indiancouriercompany.com/samples/Create_Credit_Note.csv";
              }}
            >
              Sample Sheet
            </Button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">2.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Upload updated Credit Note sheet
            </p>
          </div>
          <div className="flex gap-2 justify-center items-center ml-6">
            <UploadInput
              label=""
              placeholder="Upload Credit Note Sheet"
              note="Note: Only .csv file is allowed"
              accept=".csv"
              onChange={(file) => handleChange("bulkCreditNote", file)}
            />
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="flex gap-2 justify-end items-center mt-4">
        <SheetClose asChild>
          <Button variant="outline" size="sm">
            Cancel
          </Button>
        </SheetClose>

        <Button
          variant="default"
          size="sm"
          icon={HiOutlineUpload}
          onClick={handleUpload}
        >
          Upload Credit Note
        </Button>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </div>
  );
};

export default CreditNoteBulk;
